import { RolodexFilterOp } from 'types'

/** Load options for a site's single active pipeline-config entry. */
export function activePipelineConfigLoadOptions(siteId: string) {
  return {
    type: ['pipeline-config'],
    tags: { site: siteId },
    filters: [
      {
        field: 'data',
        key: 'status',
        op: RolodexFilterOp.EQUAL,
        value: 'active',
      },
    ],
    limit: 1,
  }
}
